<template>
  <div class="news">
    <common-layout>
      <div slot="header">
        <h3>通知公告</h3>
      </div>
      <div slot="container">
        <div class="news-search">
          <el-button
              icon="el-icon-plus"
              style="background: #623AA2; border: none;"
              type="success"
              @click="addNews"
          >新增
          </el-button>
          <el-button icon="el-icon-delete" type="danger" @click="deleteAll">批量删除</el-button>
          <el-input
              v-model="searchValue"
              class="input-with-select"
              clearable
              placeholder="请输入标题内容"
              @clear="search"
              @keyup.enter.native="search"
          >
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </div>

        <div class="news-table">
          <el-table
              ref="multipleTable"
              :data="tableData"
              :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
              class="table"
              style="width: 100%"
              @selection-change="selectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column align="center" label="序号" type="index" width="150">
              <template slot-scope="scope">
                <span>{{ scope.$index + (currentPage - 1) * per_page + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="标题">
              <template slot-scope="scope">
                <div slot="reference" class="name-wrapper">
                  <span size="medium">{{ scope.row.title }}</span>
                </div>
              </template>
            </el-table-column>

            <el-table-column align="center" label="发布时间">
              <template slot-scope="scope">
                <div slot="reference" class="name-wrapper">
                  <span size="medium">{{ scope.row.dateTime }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作">
              <template slot-scope="scope">
                <el-button
                    v-if="scope.row.isPublish == 2"
                    size="mini"
                    type="success"
                    @click="release(scope.row, 1)"
                >确认发布
                </el-button>
                <el-button v-else size="mini" type="warning" @click="release(scope.row, 2)">取消发布</el-button>
                <el-button
                    class="mini_btn"
                    size="mini"
                    type="primary"
                    @click="handleEdit(scope.$index, scope.row)"
                >编辑
                </el-button>
                <el-button
                    class="mini_btn"
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row)"
                >删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
            :current-page.sync="currentPage"
            :page-size="per_page"
            :total="total"
            layout="total, prev, pager, next"
            style="text-align:left;margin:20px 0"
            @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </common-layout>

    <el-dialog :close-on-click-modal="false" :title="Title" :visible.sync="dialogFormVisible">
      <el-form
          ref="newForm"
          :model="newForm"
          :rules="rules"
          class="demo-ruleForm"
          label-width="100px"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="标题" prop="title">
              <el-input v-model="newForm.title" clearable></el-input>
            </el-form-item>
            <el-form-item label="摘要" prop="remark">
              <el-input
                  v-model="newForm.remark"
                  :autosize="{ minRows: 3, maxRows: 400}"
                  clearable
                  type="textarea"
              ></el-input>
            </el-form-item>
            <el-form-item label="发布时间" prop="dateTime">
              <el-date-picker
                  v-model="newForm.dateTime"

                  :picker-options="pickerOptions"
                  placeholder="选择日期"
                  style="text-align: left;width:100%"
                  type="datetime"
              ></el-date-picker>
            </el-form-item>

            <el-form-item label="是否发布" prop="isPublish" style="text-align:left">
              <el-switch
                  v-model="newForm.isPublish"
                  :active-value="1"
                  :inactive-value="2"
                  :picker-options="pickerOptions"
                  active-color="#13ce66"
                  active-text="是"
                  inactive-color="#ff4949"
                  inactive-text="否"
              ></el-switch>
            </el-form-item>
          </el-col>

          <el-col :span="16">
            <el-form-item label="上传附件" style="text-align:center">
              <el-upload
                  :action="this.uploadURL"
                  :file-list="fileList"
                  :on-preview="onPreview"
                  :on-remove="onRemove"
                  :on-success="handlePictureCardPreview"
                  :show-file-list="true"
                  accept=".png, .jpg, .jpeg, .pdf, .doc, .docx"
                  class="upload-demo"
                  name="file"
              >
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row class="zhaopian1"></el-row>
        <!-- <editor :quill-data="newForm.content" :upload-url="uploadURL" :img-show-url="imgUrl" @getQuillData="getQuillData"></editor> -->
        <editor v-model="newForm.content" :img-show-url="imgUrl" :upload-url="uploadURL"></editor>

        <el-form-item style="text-align:right;margin-top:10px">
          <el-button type="primary" @click="submitForm('newForm')">提交</el-button>
          <el-button @click="closeForm('newForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
// import editor from "../../components/yhQuillEditor";
import editor from "../../components/tinymce-editor/tinymce-editor";
import CommonLayout from "../../components/common-layout.vue";
import {DisabledDateFn, FunDownload, GetUrlName} from "../../utils/tool";

export default {
  components: {
    editor,
    CommonLayout,
  },
  data() {
    return {
      pickerOptions: {
        disabledDate: this.disabledDateFn,
      },
      fileList: [],
      total: 10,
      per_page: 10,
      currentPage: 1,
      image: "",
      dialogFormVisible: false,
      searchValue: "",
      Title: "",
      current_page: 1,
      tableData: [],
      deleteRow: "",
      newForm: {
        title: "",
        annex: "",
        remark: "",
        image: "",
        content: "",
        dateTime: "",
        isPublish: 2,
      },
      rules: {
        title: [
          {
            required: true,
            message: "请输入标题",
            trigger: "blur",
          },
        ],
        dateTime: [
          {
            required: true,
            message: "请选择时间",
            trigger: "blur",
          },
        ],
        remark: [
          {
            required: true,
            message: "请输入摘要",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    headers() {
      return {};
    },
    editor() {
      return this.$refs.myQuillEditor.quill;
    },
  },
  created() {
    this.getData(`${urlConfig.devUrl}apij2/admin-api/trade/news-notice/page`, {});
  },
  methods: {
    //禁用日期选择
    disabledDateFn(time) {
      return DisabledDateFn(time);
    },
    //富文本
    getQuillData(val) {
      this.newForm.content = val;
    },
    // 获取列表
    getData(url, data) {
      this.http
          .post(url, data)
          .then((res) => {
            if (res.code == 0) {
              this.current_page = res.data.current_page;
              this.tableData = res.data.data;
              this.total = res.data.total;
              this.currentPage = res.data.current_page;
              this.per_page = res.data.per_page;
            }
          })
          .catch((err) => {
            console.log("开始搜索咨询err::", err);
          });
    },
    //新增
    addNews() {
      this.dialogFormVisible = true;
      this.Title = "新建";
      this.newForm = {
        title: "",
        remark: "",
        annex: "",
        content: "",
        dateTime: "",
        isPublish: 2,
      };
      this.fileList = [];
    },
    //编辑
    handleEdit(index, row) {
      this.dialogFormVisible = true;
      this.Title = "编辑";
      /*this.http.get("news_notice/" + row.id).then((res) => {
        if (res.code == 0) {
        }
      });*/
      this.newForm = {
        id: row.id,
        title: row.title,
        remark: row.remark,

        content: row.content,
        dateTime: row.dateTime,
        isPublish: row.isPublish,
      };
      this.fileList = row.annex
          .split(",")
          .map((el) => {
            return {
              name: GetUrlName(el),
              url: el,
            };
          })
          .filter((d) => d.url);

    },
    //删除
    handleDelete(index, row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
          .then(() => {
            this.http
                .delete(`${urlConfig.devUrl}apij2/admin-api/trade/news-notice/delete?id=${row.id}`)
                .then((res) => {
                  if (res.code === 0) {
                    this.ResetSearch(["searchValue"]);

                    this.getData(
                        `${urlConfig.devUrl}apij2/admin-api/trade/news-notice/page`, {
                          page: this.current_page,
                          keyword: this.searchValue
                        }
                    );
                    this.$message({
                      type: "success",
                      message: "删除成功",
                    });
                  } else {
                    this.$message({
                      message: "失败！",
                      type: "error",
                    });
                  }
                });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
    },
    //提交
    submitForm(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.newForm.annex = this.fileList
              .map((el) => {
                return el.url;
              })
              .join(",");
          if (this.Title === "新建") {
            this.newForm.dateTime = this.pbcFun.formatDate(
                new Date(this.newForm.dateTime),
                "yyyy-MM-dd hh:mm:ss"
            );

            this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/news-notice/create`, this.newForm).then((res) => {
              if (res.code === 0) {
                this.ResetSearch(["searchValue"]);

                this.getData(
                    `${urlConfig.devUrl}apij2/admin-api/trade/news-notice/page`, {
                      page: this.current_page,
                      keyword: this.searchValue
                    }
                );
                this.dialogFormVisible = false;
                this.$message({
                  type: "success",
                  message: "新增成功",
                });
              }
            });
          }
          if (this.Title === "编辑") {
            this.newForm.dateTime = this.pbcFun.formatDate(
                new Date(this.newForm.dateTime),
                "yyyy-MM-dd hh:mm:ss"
            );
            let obj = JSON.parse(JSON.stringify(this.newForm));
            this.http.put(`${urlConfig.devUrl}apij2/admin-api/trade/news-notice/update`, obj).then((res) => {
              if (res.code === 0) {
                this.ResetSearch(["searchValue"]);

                this.getData(
                    `${urlConfig.devUrl}apij2/admin-api/trade/news-notice/page`, {
                      page: this.current_page,
                      keyword: this.searchValue
                    }
                );
                this.dialogFormVisible = false;
                this.$message({
                  type: "success",
                  message: "编辑成功",
                });
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    //取消
    closeForm(name) {
      this.dialogFormVisible = false;
    },
    //发布
    release(row, value) {
      // this.$confirm("此操作将发布新闻, 是否继续?", "提示", {
      // 		confirmButtonText: "确定",
      // 		cancelButtonText: "取消",
      // 		type: "warning",
      // 		center: true
      // 	})
      // 	.then(() => {
      let message = value === 2 ? '取消发布' : '发布成功';
      row.isPublish = value;
      this.http
          .put(`${urlConfig.devUrl}apij2/admin-api/trade/news-notice/update`, row)
          .then((res) => {
            if (res.code === 0) {
              this.getData(
                  `${urlConfig.devUrl}apij2/admin-api/trade/news-notice/page`, {
                    page: this.current_page,
                    keyword: this.searchValue
                  }
              );
              this.$message({
                type: "success",
                message: message,
              });
            } else {
              this.$message({
                message: message,
                type: "error",
              });
            }
          });
      // })
      // .catch(() => {
      // 	this.$message({
      // 		type: "info",
      // 		message: "已取消发布"
      // 	});
      // });
    },
    //查找
    search() {
      this.getData(`${urlConfig.devUrl}apij2/admin-api/trade/news-notice/page`, {keyword: this.searchValue});
    },
    //批量删除
    deleteAll() {
      if (this.deleteRow) {
        this.$confirm("此操作将批量删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        })
            .then(() => {
              this.http
                  .delete(`${urlConfig.devUrl}apij2/admin-api/trade/news-notice/deleteAll?ids=${this.deleteRow}`)
                  .then((res) => {
                    if (res.code === 0) {
                      this.ResetSearch(["searchValue"]);

                      this.getData(
                          `${urlConfig.devUrl}apij2/admin-api/trade/news-notice/page`, {
                            page: this.current_page,
                            keyword: this.searchValue
                          }
                      );
                      this.$message({
                        type: "success",
                        message: "删除成功",
                      });
                    } else {
                      this.$message({
                        message: "失败！",
                        type: "error",
                      });
                    }
                  });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消删除",
              });
            });
      } else {
        this.$message({
          type: "warning",
          message: "请选择删除的新闻",
        });
      }
    },
    selectionChange(selection) {
      this.deleteRow = "";
      if (selection.length != 0) {
        let arr = [];
        selection.forEach((item) => {
          arr.push(item.id);
        });
        this.deleteRow = arr.join(",");
      }
    },
    //翻页
    handleCurrentChange(val) {
      this.getData(`${urlConfig.devUrl}apij2/admin-api/trade/news-notice/page`, {page: val, keyword: this.searchValue});
    },

    //其他图片上传
    createImage(file, e, Name) {
      //lrz压缩
      // lrz图片先压缩在加载、
      lrz(file, {
        width: 960,
      })
          .then((rst) => {
            this.http
                .post("/file/base64_upload", {
                  image: rst.base64,
                })
                .then((res) => {
                  this.image = res.data;
                });
            return rst;
          })
          .always(() => {
            // 清空文件上传控件的值
            e.target.value = null;
          });
    },

    handlePictureCardPreview(response, file, fileList) {
      this.fileList = this.getList(fileList);
    },
    getList(fileList) {
      return fileList.map((el) => {
        return {
          name: el.name,
          url: el?.url || el?.response?.data.store_result,
          uid: el.uid,
        };
      });
    },
    onRemove(file, fileList) {
      this.fileList = this.getList(fileList);
    },
    onPreview(file) {
      FunDownload(this.imgUrl + file.url, file.name);
    },
    deleteImg() {
      this.$confirm("确定删除图片吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
          .then(() => {
            this.image = "";
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
    },
  },
};
</script>
<style lang="scss" scoped>
.news {
  width: 100%;
  height: 100%;

  .news-search {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    // margin-top: 20px;
    .el-input {
      width: 400px;
      margin: 0 15px;
    }
  }

  .news-table {
    width: 100%;
    margin-top: 10px;
    border: 1px solid #eef1f6;
  }

  /deep/ .yh-quill-editor {
    .el-upload {
      display: none;
    }

    .ql-toolbar {
      text-align: left;
    }
  }
}
</style>
